import Vue from "vue";
import Vuex from "vuex";

import service from "../../services/workflow/delegations";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    paddingNav: "247px",
    operators: [],
    new:{},
    delegations:[],
    isShowDelegation:null
    
  },

  mutations: {
    setOperators(state, data) {
      state.operators= data;
    },
    setNew(state, data){
        state.new = data
    },
    setDelegation(state, data){
       state.delegations=data
    },
    setIsShowDelegation(state,data){
      state.isShowDelegation = data
    }
   
  },
  actions: {
    async getAvaibleOperators(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getDelegationOperatorsForId();
          state.commit("setOperators", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    getIsShowDelegation(state){
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getShowDelegationOperId();
          state.commit("setIsShowDelegation", item.puedeDelegar);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async newDelegationAct(state) {
        return new Promise(async (resolve, reject) => {
          try {
            let item = await state.state.service.newDelegation(state.state.new)
            state.commit("setDelegation", item);
            resolve(true);
          } catch (error) {
            reject(error);
          }
        });
      },
   
  },
});
